var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('EsyH1',{staticClass:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.description)?_c('EsyArticle',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.description))}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }